import { apiClient } from '../../services/api';
import { createClientRequestId } from '../../utils/clientRequestId';

const HEADERS = { 'X-Portal': 'business' };
const BASE = '/api/business/delivery';

function unwrap(response) {
  return response?.data?.data ?? response?.data ?? response;
}

export const businessCustodyReviewService = Object.freeze({
  async list(businessId) {
    const response = await apiClient.get(`${BASE}/custody-reviews`, {
      headers: HEADERS,
      params: { businessId },
    });
    return unwrap(response);
  },

  async returnToDispatch(businessId, review, { justification, idempotencyKey } = {}) {
    const response = await apiClient.post(`${BASE}/shipments/${review.shipmentId}/exceptions`, {
      businessId,
      actionCode: 'MANAGEMENT_REVIEW_RETURN_TO_DISPATCH',
      reasonCode: 'PARCEL_RETURN_CONFIRMED',
      justification,
      custodyDisposition: 'RETURNED_TO_DISPATCH',
      expectedAttemptVersion: review.attemptVersion,
      expectedStopVersion: review.stopVersion,
      expectedShipmentVersion: review.shipmentVersion,
      expectedAssignmentVersion: review.assignmentVersion,
      expectedRunVersion: review.runVersion,
    }, {
      headers: {
        ...HEADERS,
        'Idempotency-Key': idempotencyKey || createClientRequestId('custody_return'),
      },
    });
    return unwrap(response);
  },
});
